import { Inject, Injectable } from '@angular/core';
import { ACCOUNTING_EVENT_REPOSITORY, AccountingEventsRepository } from '@core/repositories/accounting-events.repository';
import { AccountingEvent } from '@shared/interfaces/accounting-event';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountingEventsService {
  constructor(
    @Inject(ACCOUNTING_EVENT_REPOSITORY) protected repository: AccountingEventsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(accountingEvent: AccountingEvent): Observable<any> {
    return this.repository.add(accountingEvent);
  }

  edit(accountingEvent: AccountingEvent): Observable<any> {
    return this.repository.edit(accountingEvent);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
